var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box_img"},[_c('img',{attrs:{"height":_vm.height,"src":_vm.src,"alt":""},on:{"click":function($event){return _vm.openView(_vm.linkUrl)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }